"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.widgetName = exports.default = exports.cssAnchorName = exports.config = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _ContentCurationList = _interopRequireDefault(require("../content-curation/ContentCurationList"));

var _ContentCurationItem = _interopRequireDefault(require("../content-curation/ContentCurationItem"));

var _Article = _interopRequireDefault(require("@insided/destination/icons/Article"));

var _Question = _interopRequireDefault(require("@insided/destination/icons/Question"));

var _Answer = _interopRequireDefault(require("@insided/shared/icons/Answer"));

var _Discussion = _interopRequireDefault(require("@insided/destination/icons/Discussion"));

var _ProductUpdate = _interopRequireDefault(require("@insided/destination/icons/ProductUpdate"));

var _Idea = _interopRequireDefault(require("@insided/destination/icons/Idea"));

var _Bug = _interopRequireDefault(require("@insided/destination/icons/Bug"));

var _zod = require("zod");

var _classnames = _interopRequireDefault(require("classnames"));

var _widgetContainer = _interopRequireWildcard(require("../widget-container"));

var _common = require("@insided/shared/utils/common");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var widgetName = 'recommendations';
exports.widgetName = widgetName;
var cssAnchorName = 'widget-recommendations';
exports.cssAnchorName = cssAnchorName;

var config = _zod.z.object({
  curatedTopics: _zod.z.number().array()
}).merge(_widgetContainer.widgetContainerConfig);

exports.config = config;

var Recommendations = function Recommendations(props) {
  var config = props.config,
      _props$curatedTopics = props.curatedTopics,
      curatedTopics = _props$curatedTopics === void 0 ? [] : _props$curatedTopics;

  var isBugContentTypeEnabled = _common.common.isModuleActive('bugContentType');

  var topicType = {
    question: (0, _preact.h)(_Question.default, null),
    article: (0, _preact.h)(_Article.default, null),
    answer: (0, _preact.h)(_Answer.default, null),
    discussion: isBugContentTypeEnabled ? (0, _preact.h)(_Bug.default, null) : (0, _preact.h)(_Discussion.default, null),
    conversation: isBugContentTypeEnabled ? (0, _preact.h)(_Bug.default, null) : (0, _preact.h)(_Discussion.default, null),
    productUpdate: (0, _preact.h)(_ProductUpdate.default, {
      width: 24,
      height: 24
    }),
    idea: (0, _preact.h)(_Idea.default, null)
  };

  if (!curatedTopics.length) {
    return null;
  }

  return (0, _preact.h)(_widgetContainer.default, {
    config: config,
    widgetName: "knowledge-base"
  }, (0, _preact.h)("div", {
    className: (0, _classnames.default)('topic-curation__container', 'full-width', 'custom-featured-topic-list')
  }, (0, _preact.h)("div", {
    className: "sitewidth"
  }, curatedTopics.length ? (0, _preact.h)(_ContentCurationList.default, null, curatedTopics.map(function (item, idx) {
    item.icon = topicType[item.type];
    item.idx = idx;
    return (0, _preact.h)(_ContentCurationItem.default, (0, _extends2.default)({
      key: item.id
    }, item));
  })) : null)));
};

var _default = Recommendations;
exports.default = _default;